import React from "react";
import PropTypes from "prop-types";


import { StyledHTMLLink, StyledRouterLink } from "./styles";
/*
* Return a link. Includes router, active state and other accessibility and performance handlers.
*/
export const LinkHandler = ({
  clientContext = null,
  context = null,
  styles = null,
  to = null,
  isExternalLink = false,
  // isNavigation = false,
  children = null,
}) => {
  let { isAmp } = context || false;

  let isExternal = /^https?:\/\//.test(to);

  if (isExternal === true || isExternalLink === true || isAmp === true) {
    return  <StyledHTMLLink href={to}>{children}</StyledHTMLLink>
  }
  //
  // if (isNavigation === true) {
  //   return <StyledRouterNavLink to={to} styles={styles}>{children}</StyledRouterNavLink>;
  // }

  return <StyledRouterLink to={to} styles={styles}>{children}</StyledRouterLink>;
  // return <div>{children}</div>;
};

export default LinkHandler;

LinkHandler.propTypes = {
  /**
   Path to link
  */
  to: PropTypes.string,
  /**
   Is an External Link
  */
  isExternalLink: PropTypes.bool,
  /**
   If link is used in Router navigation (Header, Footer)
  */
  isNavigation: PropTypes.bool,
};

/**
* Used by Make a List
// */
// export const ensureSearch = (Component) => ({ to, onClick, ...rest }) => {
//   const location = useLocation();
//   const history = useHistory();
//   const href = useMemo(
//     () =>
//       typeof to === "string"
//         ? {
//             pathname: to,
//             search: location.search,
//           }
//         : {
//             ...to,
//             search: [
//               "?",
//               [
//                 location.search.substr(1).split("&"),
//                 (typeof to.search === "string" ? to.search : "?")
//                   .substr(1)
//                   .split("&"),
//               ]
//                 .flat()
//                 .filter(Boolean)
//                 .join("&"),
//             ].join(""),
//           },
//     [to, location]
//   );
//   const interactionOverride = useCallback(
//     (e) => {
//       e.preventDefault();
//       // console.log(onClick);
//       if (onClick) {
//         onClick(e, href);
//       }
//       history.push(href);
//     },
//     [history, href]
//   );
//   return <Component onClick={interactionOverride} to={href} {...rest} />;
// };
